// use .env file to change the environment
export const NODE_ENV = process.env.REACT_APP_NODE_ENV || "qa";
